import React from 'react';
import { Layers, Truck, BarChart3, MapPin } from 'lucide-react';

const WhatIsTrendrush = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            What is <span className="text-coral">Trendrush?</span>
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            A tech and logistics platform empowering retailers to compete in quick commerce—not just another delivery service.
          </p>
        </div>

        {/* Key Differentiators */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="text-center p-6">
            <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-coral-light flex items-center justify-center">
              <Layers className="w-8 h-8 text-coral" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Tech Platform</h3>
            <p className="text-gray-600">Online presence for every retail store</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-coral-light flex items-center justify-center">
              <Truck className="w-8 h-8 text-coral" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Logistics Network</h3>
            <p className="text-gray-600">Direct shipping from stores to consumers</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-coral-light flex items-center justify-center">
              <BarChart3 className="w-8 h-8 text-coral" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Data Intelligence</h3>
            <p className="text-gray-600">Consumer insights to optimize inventory</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-coral-light flex items-center justify-center">
              <MapPin className="w-8 h-8 text-coral" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Hyperlocal Focus</h3>
            <p className="text-gray-600">Stores become neighborhood warehouses</p>
          </div>
        </div>

        {/* Visual Breakdown */}
        <div className="bg-gradient-to-br from-gray-50 to-cream/20 rounded-3xl p-12 shadow-lg border border-gray-100">
          <div className="grid lg:grid-cols-3 gap-12">
            <div className="space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gray-300 flex items-center justify-center text-white font-bold text-xl">
                ✗
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Delivery Apps</h3>
              <p className="text-gray-600">Just delivery. No tech or data for retailers.</p>
            </div>

            <div className="space-y-4">
              <div className="w-12 h-12 rounded-xl bg-gray-300 flex items-center justify-center text-white font-bold text-xl">
                ✗
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Traditional E-commerce</h3>
              <p className="text-gray-600">3-5 days from central warehouses.</p>
            </div>

            <div className="space-y-4">
              <div className="w-12 h-12 rounded-xl bg-coral flex items-center justify-center text-white font-bold text-xl">
                ✓
              </div>
              <h3 className="text-2xl font-bold text-coral">Trendrush</h3>
              <p className="text-gray-600">Minutes delivery + Tech + Logistics + Data insights.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsTrendrush;
